// Test IDs for the "what we keep" notice shown on entry and around the fields
// that hold personal data.

export const PRIVACY = {
	note: 'privacy-note',
	toggle: 'privacy-note-toggle',
	details: 'privacy-note-details',
	bodyFields: 'privacy-hint-body-fields',
	allergies: 'privacy-hint-allergies',
};
